module.exports = __webpack_public_path__ + "assets/e37ada2e0e9597fa2f6076a67184f3e8.mp3";